import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'

import PropTypes from 'prop-types'

import './benefit-card.css'

const BenefitCard = (props) => {
  return (
    <div className="column benefit-card flex-1 gap-2">
      <img
        alt="image"
        src={props.thumbnailSrc}
        className="benefit-card-thumbnail"
      />
      <div className="benefit-card-container1 column gap-3-5">
        <div className="benefit-card-container2 column gap-2 align-start">
          <span className="benefit-card-title news-card-featured-title">
            {props.title ?? (
              <Fragment>
                <span className="benefit-card-text3">
                  Article Headline
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </Fragment>
            )}
          </span>
          <span className="benefit-card-text1">
            {props.text ?? (
              <Fragment>
                <span className="benefit-card-text2">
                  Charge quickly and easily with iCharge at over 50 stations
                  across Albania.
                </span>
              </Fragment>
            )}
          </span>
          <Link to="/who-can-benefit">
            <div className="benefit-card-container3 row align-center justify-between full-width">
              <svg
                width="48"
                xmlns="http://www.w3.org/2000/svg"
                height="30"
                viewBox="0 0 23 12"
                className="benefit-card-icon1"
              >
                <path d="M-9.09339e-06 6.67573L20.1537 6.67573L15.6111 10.8165L16.632 11.7471L22.9174 6.01777L16.632 0.288388L15.6111 1.21898L20.1537 5.35972L-8.97834e-06 5.35972L-9.09339e-06 6.67573Z"></path>
              </svg>
            </div>
          </Link>
        </div>
      </div>
    </div>
  )
}

BenefitCard.defaultProps = {
  text: undefined,
  title: undefined,
  thumbnailSrc: 'https://play.teleporthq.io/static/svg/default-img.svg',
  rootClassName: '',
}

BenefitCard.propTypes = {
  text: PropTypes.element,
  title: PropTypes.element,
  thumbnailSrc: PropTypes.string,
  rootClassName: PropTypes.string,
}

export default BenefitCard
